// import Slider from "./slider/Slider";
import bannerImg1 from "../../assets/images/bannerImage1.png";
import bannerImg2 from "../../assets/images/bannerImage2.png";
import bannerImg from "../../assets/images/bannerImage.png";
import styled from "styled-components";
import { useEffect, useMemo, useState } from "react";
import { get } from "../../helpers/api_helpers";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const HomeSlider = ({ page }) => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const loadBanners = async () => {
      try {
        const response = await get(`/banners?page=${page}&source=web`);
        const bannerList = response?.result?.banners || [];
        console.log("checkBanners", bannerList);
        const filtered = bannerList.filter((banner) => {
          const pages = (banner?.pages || "").toLowerCase();
          return pages.includes("all") || pages.includes("home");
        });
        setBanners(filtered.slice(0, 3));
      } catch (error) {
        setBanners([]);
      }
    };
    loadBanners();
  }, []);

  const bannerImages = useMemo(() => {
    const defaults = [bannerImg1, bannerImg2, bannerImg];
    if (!banners.length) {
      return defaults;
    }
    console.log("banners", banners);
    const fromApi = banners
      .map((item) => item?.banner_image || item?.banner_image_mobile)
      .filter(Boolean);
    return [...fromApi, ...defaults].slice(0, 3);
  }, [banners]);

  // return <Slider />;
  // return (
  //   <BannerWrapper>
  //     <BannerText>
  //       <h1>
  //         Discover the No. 1 Pet Clinic
  //         <span className="textBold"> Near You</span>
  //       </h1>
  //       <p className="lightText">
  //         Where Exceptional Care Meets Peace of Mind! Your Furry Friend Deserves
  //         The Best .
  //       </p>
  //       <SecondaryBtn className="bg-theme-colored">Book an Appointment</SecondaryBtn>
  //       <img className="mobileTextImg" src={bannerImages[2]} alt="Banner Image" />
  //     </BannerText>
  //     <BannerImg>
  //       <img className="desktop" src={bannerImages[0]} alt="Banner Image" />
  //       {/* <img
  //         src={bannerImages[1]}
  //         alt="Banner Image"
  //         className="secondImg desktop"
  //       /> */}
  //       <img className="mobile" src={bannerImages[2]} alt="Banner Image" />
  //     </BannerImg>
  //   </BannerWrapper>

  // );

  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      loop={true}
      pagination={{ clickable: true }}
    >
      {banners.length > 0 ? (
        banners.map((banner, index) => (
          <SwiperSlide key={index}>
            <BannerWrapper>
              {/* 1. Background Image Layer */}
              <BackgroundImageContainer>
                <img
                  className="desktop"
                  src={banner?.banner_image}
                  alt="Banner"
                />
                <img
                  className="mobile"
                  src={banner?.banner_image}
                  alt="Banner"
                />
              </BackgroundImageContainer>
              {/* ✅ TEXT FROM API */}
              {/* 2. Content Overlay Layer */}
              <BannerContentOverlay>
                <div
                  dangerouslySetInnerHTML={{
                    __html: banner?.banner_text || "",
                  }}
                />
              </BannerContentOverlay>

              {/* ✅ IMAGES FROM API */}
              {/* <BannerImg>
                <img
                  className="desktop"
                  src={banner?.banner_image}
                  alt="Banner"
                />

                <img
                  className="mobile"
                  src={banner?.banner_image}
                  alt="Banner"
                />
              </BannerImg> */}
            </BannerWrapper>
          </SwiperSlide>
        ))
      ) : (
        /* ✅ FALLBACK SLIDE */
        <SwiperSlide>
          <BannerWrapper>
            <BannerText>
              <h1>
                Discover the No. 1 Pet Clinic ....
                <span className="textBold"> Near You</span>
              </h1>
              <p className="lightText">
                Where Exceptional Care Meets Peace of Mind! Your Furry Friend
                Deserves The Best .
              </p>
              <Link to="/clinic">
                <SecondaryBtn className="bg-theme-colored">
                  Book an Appointment
                </SecondaryBtn>
              </Link>
            </BannerText>

            <BannerImg>
              <img className="desktop" src={bannerImg1} alt="Banner" />
              <img className="mobile" src={bannerImg} alt="Banner" />
            </BannerImg>
          </BannerWrapper>
        </SwiperSlide>
      )}
    </Swiper>
  );
};

export default HomeSlider;

export const SecondaryBtn = styled.button`
  padding: 1rem 3rem;
  font-size: 18px;
  color: #fff;
  background-color: #07b1f1;
  border-radius: 15px;
  transition: all ease-in-out;
  transition-duration: 300ms;
  z-index: 3;

  @media only screen and (max-width: 576px) {
    padding: 10px 15px;
    font-size: 15px;
    border-radius: 15px;
  }
`;

export const BannerImg = styled.div`
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .mobile {
    display: none;
  }

  img {
    max-width: 90%;
  }

  .secondImg {
    position: absolute;
    right: 9%;
    top: -14%;
    max-width: 25%;
    z-index: 101;
  }

  .mainImage {
    position: absolute;
    right: -5%;
    max-width: 78%;
    bottom: -10%;
    z-index: 101;
  }

  .firstImage {
    position: absolute;
    right: 26%;
    width: 32%;
    bottom: 0;
  }

  .middleImage {
    position: absolute;
    right: 26%;
    max-width: 17%;
    bottom: 0;
  }

  .thirdImage {
    position: absolute;
    right: 3%;
    bottom: 0px;
    width: 27%;
    z-index: 101;
  }
  .clinicFirst {
    position: absolute;
    right: 28%;
    max-width: 27%;
    bottom: 0;
    display: flex;
  }
  .clinicThird {
    position: absolute;
    right: 6%;
    bottom: -2%;
    width: 30%;
    z-index: 101;
  }
  .clinicInnerFirst {
    position: absolute;
    right: 32%;
    width: 22%;
    bottom: 0%;
  }
  .clinicInnerThird {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 43%;
    z-index: 101;
  }

  @media only screen and (max-width: 900px) {
    width: 50%;

    .desktop {
      display: none;
      position: absolute;
    }

    .mobile {
      display: block;
    }
  }

  @media only screen and (max-width: 576px) {
    display: block;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 1;
    opacity: 0.5;

    .clinicInnerThird {
      width: 80%;
    }

    .clinicInnerFirst {
      right: 60%;
      width: 40%;
    }

    .clinicFirst {
      right: 58%;
      max-width: 80%;
      bottom: 0;
      display: flex;
      z-index: auto;
    }

    .clinicThird {
      position: absolute;
      right: 6%;
      bottom: -2%;
      width: 80%;
      z-index: auto;
    }

    .mobileTextImg {
      display: block;
      width: 300px;
      position: absolute;
      right: -30px;
      z-index: 0;
      opacity: 0.4;
      bottom: -70px;
    }

    .firstImage {
      right: 18%;
      width: 92%;
    }

    .middleImage {
      max-width: 50%;
    }

    .thirdImage {
      width: 60%;
    }

    .mainImage {
      max-width: 98%;
      bottom: -20%;
    }
  }
`;

export const BannerText = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 1rem;

  .lightText {
    color: #797979;
    font-size: 17px;
    font-family: Montserrat;
    font-weight: normal;
    z-index: 3;
  }

  .mobileTextImg {
    display: none;
  }

  @media only screen and (max-width: 900px) {
    width: 60%;

    .lightText {
      font-size: 16px;
      line-height: normal;
    }
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
    position: relative;
    z-index: 9;
  }
`;

export const BannerWrapper = styled.div`
  width: 100%;
  /* min-height: 500px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 2rem 5rem;
  background: #f2f8fa;
  height: 65vh;
  position: relative;

  h1 {
    color: #515050;
    font-size: 35px;
    font-family: Montserrat;
    font-weight: lighter;
  }

  .textBold {
    color: #00419d;
    font-weight: bold;
    font-size: 45px;
    letter-spacing: 6px;
    margin: 0;
    text-transform: uppercase;
  }

  @media only screen and (max-width: 900px) {
    align-items: flex-start;
    height: 45vh;
    padding: 2rem;
    padding-top: 3rem;

    h1 {
      width: 270px;
      font-size: 25px;
      margin: 0;
    }

    .textBold {
      font-size: 35px;
      letter-spacing: 4px;
    }
  }
`;

export const BackgroundImageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* This makes the image cover the area without stretching */
  }

  .mobile {
    display: none;
  }

  @media (max-width: 768px) {
    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }
  }
`;

export const BannerContentOverlay = styled.div`
  position: relative;
  z-index: 2; /* Sits on top of the image */
  text-align: center;
  color: #ffffff; /* White text looks best on backgrounds */
  padding: 20px;
  max-width: 800px;

  /* Optional: Add a text shadow to make text readable on busy images */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);

  /* Optional: Add a slight dark overlay to the image if text is hard to read */
  &::before {
    /* content: ""; */
    /* position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.3); z-index: -1; */
  }
`;
